<template>
  <loading v-if="loading" />
  <div id="wrapper" class="noheader" v-if="view === 'info'">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>檢驗資料</p>
          <span></span>
        </div>
        <a v-if="notFromLine" class="arr" @click="$router.replace(from)"
          ><div class="inner"></div
        ></a>
      </div>
      <div class="examineListBox">
        <div class="tabs">
          <a :class="active.全部" @click="changeTab('全部')"><p>全部</p></a>
          <a :class="active.檢驗報告" @click="changeTab('檢驗報告')"
            ><p>檢驗報告</p></a
          >
          <a :class="active.影像報告" @click="changeTab('影像報告')"
            ><p>影像報告</p></a
          >
        </div>
        <div
          style="margin-top:-1.8rem; margin-bottom:1rem; position:relative; text-align: center;"
          v-if="member.info.child.length > 0 && member.info.verified !== 0"
        >
          <a>
            {{ currentPatient.name }}
          </a>
          <img
            style="display:inline; position:absolute; right: 0px; top: 1.5px;"
            width="11"
            height="11"
            src="@/assets/images/icon_change.svg"
          />
          <a
            style="position:absolute; right: 16px; color: orange;"
            @click="changeCurrent"
          >
            切換身份
          </a>
        </div>
        <div class="lists" v-if="showInfo.length !== 0">
          <div
            class="box"
            v-for="(data, index) in showInfo"
            :key="index"
            @click="showList(data)"
          >
            <div class="date">{{ data.date }}</div>
            <div class="txt">
              {{ data.dr }}
              <label style="position:absolute; right:30px;">{{
                data.photo.length + data.video.length
              }}</label>
            </div>
          </div>
        </div>
        <div class="lists" v-else>
          <p style="text-align: center;">
            {{ message === null ? "目前尚無資料" : message }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div id="wrapper" class="noheader" v-else-if="view === 'list'">
    <div class="content">
      <div class="examineDataBox">
        <div class="txt">
          <a class="arr" @click="back"><div class="inner"></div></a>
          <p>{{ listData.date }}</p>
        </div>
        <div class="data">
          <div class="formBox" v-if="listData.video.length > 0">
            <h3 style="text-align: center;">靜態影像</h3>
          </div>
          <div class="grid">
            <a
              v-for="(photo, index) in listData.photo"
              :key="photo"
              @click="showDetail(photo.origin, 'photo', index)"
              ><img
                :src="photo.thumb"
                height="100"
                style="object-fit: cover; border: 1px solid #c0c0c0;"
            /></a>
          </div>

          <div class="formBox" v-if="listData.video.length > 0">
            <br />
            <hr style="border: 2px solid #c0c0c0" />
            <br />
            <h3 style="text-align: center;">動態影像</h3>
          </div>

          <div class="grid">
            <a v-for="(video, index) in listData.video" :key="video">
              <img
                style="margin-bottom: 20px; width: 100%;"
                src="@/assets/images/video_preview.jpg"
                @click="showDetail(video.video, 'video', index)"
              />
            </a>
          </div>
          <div style="text-align: center; margin-top: 1rem;">
            可點擊圖片查看大圖
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modalBox type3" v-else-if="view === 'detail'">
    <a class="closeBtn" @click="view = 'list'"
      ><img src="@/assets/images/modal_close.svg" width="24" /><span
        >關閉</span
      ></a
    >
    <div class="inner">
      <img v-if="detailData.type === 'photo'" :src="detailData.data" />
      <video
        style="width: 100%;"
        v-else
        :src="detailData.data"
        controls
        autoplay
        muted
      />
      <div class="txt">
        <p class="date">{{ listData.date }}</p>

        <div v-if="detailData.type === 'photo'">
          <p>請長按圖片下載</p>
          <!-- <p @click="liffSendMessage(detailData)">透過Line訊息傳送影片</p> -->
        </div>

        <div v-else>
          <p @click="downloadVideo(detailData.data)">請點此下載影片</p>
          <!-- <p @click="liffSendMessage(detailData)">
            透過Line訊息傳送影片
          </p> -->
        </div>
      </div>
    </div>
  </div>

  <div id="wrapper" class="noheader" v-else-if="view === 'content'">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>檢驗資料</p>
          <span></span>
        </div>
        <a v-if="notFromLine" class="arr" @click="$router.replace(from)"
          ><div class="inner"></div
        ></a>
      </div>
      <div class="examineDataBox">
        <div class="txt">
          <a class="arr" @click="back"><div class="inner"></div></a>
          <p>{{ detailContent.title }}</p>
        </div>
        <div class="report">
          <div
            class="record"
            v-for="(record, idx) in detailContent.content"
            :key="idx"
          >
            <div class="item">
              <div>檢驗項目：</div>
              <div>{{ record.name }}</div>
            </div>
            <div class="item">
              <div>結果：</div>
              <div :style="resultCss(record.color)">{{ record.value }}</div>
            </div>
            <div class="item">
              <div>單位：</div>
              <div>{{ record.unit }}</div>
            </div>
            <div class="item">
              <div>參考值：</div>
              <div>{{ record.reference }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <modal v-if="modal.display" @close="modal.display = false">
    <template v-slot:header v-if="modal.header">{{ modal.header }}</template>
    <template v-slot:body>{{ modal.body }} </template>
  </modal>
</template>

<script>
import liff from "@line/liff";
import api from "../api/index";

export default {
  data() {
    return {
      loading: false,
      view: "info",
      info: [],
      active: {
        全部: "active",
        檢驗報告: null,
        影像報告: null
      },
      modal: {},
      listData: { date: null, photo: [], video: [] },
      detailData: {},
      message: null,
      detailContent: [],
      downloadInfo: {}
    };
  },
  computed: {
    member() {
      return this.$store.state.member;
    },
    from() {
      return this.$store.state.from;
    },
    showInfo() {
      if (this.active.全部 === "active") {
        return this.info;
      } else if (this.active.檢驗報告 === "active") {
        return this.info.filter(data => data.type === "sc");
      } else {
        return this.info.filter(data => data.type === "us");
      }
    },
    notFromLine() {
      return !this.from.includes("MedicalInfo");
    },
    patients() {
      if (this.member.info.child) {
        const patients = this.member.info.child.map(c => c.patientNo); //['寶病歷號','寶病歷號']
        patients.unshift(this.member.info.patientNo); //['媽病歷號','寶病歷號','寶病歷號']
        return patients;
      } else {
        return [this.member.info.patientNo]; //['媽病歷號']
      }
    },
    currentPatient() {
      if (this.member.info.child) {
        if (this.member.info.current === this.member.info.patientNo) {
          return this.member.info;
        } else {
          const child = this.member.info.child.find(
            c => c.patientNo === this.member.info.current
          );
          return child;
        }
      } else {
        return this.member.info;
      }
    }
  },
  methods: {
    liffSendMessage() {
      const message = `${this.listData.date},${this.detailData.type},${this.detailData.index}`;
      console.log(message);
      liff.sendMessages([
        {
          type: "text",
          text: message
        }
      ]);
    },
    changeCurrent() {
      const current = this.member.info.current;
      const idx = this.patients.indexOf(current);
      const next = idx + 1 < this.patients.length ? idx + 1 : 0;
      const patient = this.patients[next];
      console.log(
        `Current ${current} at: ${idx}, next is ${patient} at: ${next}`
      );
      this.loading = true;
      api.member
        .change({
          jwt: this.member.jwt,
          action: "setCurrent",
          current: patient
        })
        .then(data => {
          this.loading = false;
          this.$store.dispatch("login", {
            jwt: data.jwt,
            platform: this.member.platform,
            info: data.member,
            params: this.member.params
          });
          this.loadData();
        })
        .catch(error => {
          this.loading = false;
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },
    openWindow(url, external) {
      liff.openWindow({
        url: url,
        external: external
      });
    },
    downloadVideo(url) {
      const separator = url.includes("?") ? "&" : "?";
      liff.openWindow({
        url: `${url}${separator}download=1`,
        external: true
      });
    },
    changeTab(tab) {
      const keys = Object.keys(this.active);
      for (let i = 0; i < keys.length; i++) {
        this.active[keys[i]] = null;
      }
      this.active[tab] = "active";
      this.category = tab;
    },
    showList(data) {
      if (data.pdf) {
        //console.log("PDF", data.photo[0].thumb);
        this.openWindow(data.photo[0].thumb, false);
        return false;
      }
      if (data.txt) {
        //console.log(data.content);
        this.view = "content";
        this.detailContent = {
          title: data.dr,
          content: data.content
        };
        return false;
      }
      this.listData = { date: null, photo: [], video: [] };
      const photoKeys = Object.keys(data.photo);
      const videoKeys = Object.keys(data.video);
      for (let i = 0; i < photoKeys.length; i++) {
        this.listData.photo.push({
          thumb: data.photo[photoKeys[i]].thumb,
          origin: data.photo[photoKeys[i]].origin
        });
      }
      for (let i = 0; i < videoKeys.length; i++) {
        this.listData.video.push(data.video[videoKeys[i]]);
      }
      this.listData.date = data.date;
      this.view = "list";
    },
    showDetail(data, type, index) {
      this.detailData.data = data;
      this.detailData.type = type;
      this.detailData.index = index;
      this.view = "detail";
    },
    back() {
      this.view = "info";
    },
    loadData() {
      function compare(a, b) {
        if (a.date < b.date) {
          return -1;
        }
        if (a.date > b.date) {
          return 1;
        }
        return 0;
      }

      if (this.member.info.verified !== 1) {
        this.message = "請先申請帳號並完成驗證後方能查詢。";
        return false;
      }
      this.info = [];
      this.loading = true;
      api.pacsImage
        .query({
          jwt: this.member.jwt,
          current: this.currentPatient,
          modality: "SC"
        })
        .then(data => {
          for (let i = 0; i < data.images.length; i++) {
            let tmp = data.images[i];
            tmp["type"] = "sc";
            this.info.push(tmp);
            this.info.sort(compare);
            this.info.reverse();
          }
          this.loading = false;
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "網路異常",
            body: error.message
          };
          this.loading = false;
        });
      api.pacsImage
        .query({
          jwt: this.member.jwt,
          current: this.currentPatient,
          modality: "US"
        })
        .then(data => {
          for (let i = 0; i < data.images.length; i++) {
            let tmp = data.images[i];
            tmp["type"] = "us";
            this.info.push(tmp);
            this.info.sort(compare);
            this.info.reverse();
          }
          this.loading = false;
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "網路異常",
            body: error.message
          };
          this.loading = false;
        });

      // MUS-451 新增ES內視鏡影像
      api.pacsImage
        .query({
          jwt: this.member.jwt,
          current: this.currentPatient,
          modality: "ES"
        })
        .then(data => {
          for (let i = 0; i < data.images.length; i++) {
            let tmp = data.images[i];
            tmp["type"] = "us";
            this.info.push(tmp);
            this.info.sort(compare);
            this.info.reverse();
          }
          this.loading = false;
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "網路異常",
            body: error.message
          };
          this.loading = false;
        });
      //console.log(this.info);
    },
    resultCss(color) {
      return { color };
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style scoped>
img {
  border-radius: 3px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 100px;
  grid-gap: 2px;
  row-gap: 2px;
  text-align: center;
}

.record {
  padding: 1rem 0px;
  border-top: 1px solid #ddd;
  line-height: 1.6rem;
}

.record .item {
  display: grid;
  grid-template-columns: 1fr 3fr;
}

.record .item div:nth-child(2) {
  text-align: right;
}

.examineDataBox .report,
.examineDataBox img {
  border-bottom: 1px solid #ddd;
}
</style>
